import useFetchAgency from 'components/domain/agency/useFetchAgency';
import useAppUser from 'hooks/useAppUser';
import { useTranslation } from 'react-i18next';
import { IntegrationsBadgeFilter } from 'pages/integrations/IntegrationsTabs.constants';
import AgencyConfirmationWarning from '../components/agencyConfirmationWarning/AgencyConfirmationWarning';
import TabHeader from '../components/tabHeader/TabHeader';
import ChannelsTable from './channelsTable/ChannelsTable';

const DirectChannelsTab = () => {
  const { t } = useTranslation();
  const { agencyUid } = useAppUser();
  const { data, isLoading } = useFetchAgency({
    agencyUid: agencyUid as string,
  });

  const isAgencyConfirmed = data?.agencyConfirmed ?? false;
  const displayAgencyConfirmationWarning = !isLoading && !isAgencyConfirmed;

  return (
    <section>
      <TabHeader title={t('pageChannels.directChannels.title')} />

      {displayAgencyConfirmationWarning && <AgencyConfirmationWarning />}

      <ChannelsTable
        title={t('pageChannels.directChannels.popularChannelsTitle')}
        isAgencyConfirmed={isAgencyConfirmed}
        badgeFilter={IntegrationsBadgeFilter.WITH_BADGES}
      />

      <ChannelsTable
        title={t('pageChannels.directChannels.othersChannelsTitle')}
        isAgencyConfirmed={isAgencyConfirmed}
        badgeFilter={IntegrationsBadgeFilter.WITHOUT_BADGES}
      />
    </section>
  );
};

export default DirectChannelsTab;
